export class Market {
  name: string;
  partner_id: string;
  market_id: string;

  constructor(data: any) {
    Object.assign(this, data);
    if (data.pid) {
      this.partner_id = data.pid;
    }
  }
}
